import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {PaymentSearch} from "./PaymentSearch";

const ClaimSearch: ISearch = {
    searchName: "Find Claim",
    renderOptions: { ui5ResourceId: "ClaimSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: []
}

const vUI_Claim_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_CLM_ID:        {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Claim WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    CLAIM_ID:         {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim ID', columnResourceName: 'colClaimId', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    CLAIM_NAME:       {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim Name', columnResourceName: 'colClaimName', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 256}},
    CLAIM_COMMENTS:   {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim Note', columnResourceName: 'colClaimComments', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 1333}},
    CUSTOMER_NAME:    {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Customer', columnResourceName: 'colCustomer', alignment: HorizAlignment.Left}, domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    WB_CLMTYPE_ID:    {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Claim Type WB Id', columnResourceName: 'colTypeId', alignment: HorizAlignment.Center},  domainOptions: {}},
    CLAIM_TYPE_NAME:  {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim Type', columnResourceName: 'colClaimType', alignment: HorizAlignment.Left}, domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    WB_CUST_ID_CLAIM: {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Claim Customer WB Id', columnResourceName: 'colClaimCustId', alignment: HorizAlignment.Center}, domainOptions: {}},
    REASON_ID:        {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Reason', columnResourceName: 'colReason', alignment: HorizAlignment.Center},  domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    CLAIM_DT:         {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim Date', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    CLAIM_AMT:        {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Claim Amount', columnResourceName: 'colId', alignment: HorizAlignment.Right}, domainOptions: {}},
    CURRENCY:         {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Currency', columnResourceName: 'colCurrency', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    STATUS_NAME:      {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim Status', columnResourceName: 'colClaimStatus', alignment: HorizAlignment.Left}, domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    CHECK_NO:         {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Check #', columnResourceName: 'colCheck', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
    SETTLED_AMT:      {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Settlement Amount', columnResourceName: 'colSettleAmt', alignment: HorizAlignment.Right}, domainOptions: {}},
    SETTLED_STATUS:   {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Settlement Status', columnResourceName: 'colSettleStatus', alignment: HorizAlignment.Center}, domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const ClaimSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_CLM_ID',
                id_ui: 'CLAIM_ID',
                name:  'CLAIM_COMMENTS'},


    searchProviderFields: vUI_Claim_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Claim_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    if(res.length > 0) {
                        _.forEach(res, (data) => {
                            data.CLAIM_AMT = _.toNumber(data.CLAIM_AMT)
                        })
                    }
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Claim_Search',
                this.searchProviderFields,
                [fieldName])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    if(res.length > 0) {
                        _.forEach(res, (data) => {
                            data.CLAIM_AMT = _.toNumber(data.CLAIM_AMT)
                        })
                    }
                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


const ClaimSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "ClaimSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',         searchProviderFieldId: 'CLAIM_ID', renderOptions: {}},
        {profileFilterName: 'Name',       searchProviderFieldId: 'CLAIM_NAME', renderOptions: {}},
        {profileFilterName: 'Customer',   searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Claim Type', searchProviderFieldId: 'CLAIM_TYPE_NAME', renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Status',     searchProviderFieldId: 'STATUS_NAME', renderOptions: {}, bMultiSelect: true},
        // {profileFilterName: 'Claim Date', searchProviderFieldId: 'CLAIM_DT', renderOptions: {}},
    ],  // ISearchFields
    profileDisplayFields: [
        'CLAIM_ID','CLAIM_NAME','CLAIM_TYPE_NAME','CUSTOMER_NAME', 'CLAIM_DT', 'CLAIM_AMT','CURRENCY','STATUS_NAME', 'SETTLED_AMT',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ClaimSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

ClaimSearch.searchProfiles.push(ClaimSearchProfileByName)

PAEnvironment.registerBusinessObjectSearch("ClaimBO", "Claim", ClaimSearch, "Claim Search")

export {ClaimSearch}
